<body>

    <app-comment-element [user]="user" [commentType]="commentType" [comment]="comment" [videoCommentId]="videoCommentId"
        [isActionClick]="isActionClick" [replyCount]="replyCount" (onViewSubReplyClick)="getSubComment($event)"
        (newSubComment)="addNewSubComment($event)" (onMoreActionClick)="onMoreActionClick()"
        (deleteCommentElement)="deleteComment($event)" [replying]="focusComment" />

    <div *ngIf="displaySubComment" class="sub-comments-container">

        @for(subComment of (subComments$ | async); track $index){
        <app-comment-element [commentType]="commentType" [subComment]="true" [user]="user"
            [isActionClick]="isActionClick === subComment.id ?isActionClick : ''" [comment]="subComment"
            [videoCommentId]="videoCommentId" (onMoreActionClick)="onSubMoreActionClick()"
            (deleteCommentElement)="deleteComment($event)" />
        }
    </div>

    <!-- Skeleton -->
    <div class="sub-comment-skeleton-container" *ngIf="subCommmentLoading$ | async">
        <div class="sub-comment-skeleton-element" *ngFor="let replySkeleton of [].constructor(replyCount | async)">
            <p-skeleton size="40px" shape="circle" />
            <p-skeleton width="100%" height="3em" class="sub-comment-skeleton" />
        </div>
    </div>

</body>